/**
 * The light and the dark theme of the terminal.
 *
 * Each user picks one on this terminal (`pickTheme` in `auth-helper.ts`, F8 in the top bar), and the theme of the last
 * user stays for the login page, like the language (see `getTheme` in `session.ts`). The colours are CSS custom
 * properties (`assets/scss/base.scss`): `:root` has the light ones, `[data-theme='dark']` on `<html>` the dark ones.
 *
 * Function components get the theme from `useTheme` (`hooks/use-theme.ts`).
 */
import type {Theme} from './session';
import {getTheme, subscribe} from './session';

/** The other theme, for the toggle. */
export const otherTheme = (theme: Theme): Theme => ('dark' === theme ? 'light' : 'dark');

// set once here, next to the theme, instead of in a component that StrictMode mounts twice; this also follows a theme
// picked in another tab
const applyDocumentTheme = (): void => {
    document.documentElement.dataset.theme = getTheme();
};

applyDocumentTheme();
subscribe(applyDocumentTheme);
